import { defineComponent as _defineComponent } from 'vue'
import { useVuetify } from '@/services/useVuetify'
import { computed } from 'vue'
import { IEventPreview } from '@/enitites/event/model/types'
import EventCardMobile from './EventPreviewBaseCardMobile.vue'
import EventCardDesktop from './EventPreviewBaseCardDesktop.vue'

interface IProps {
  previewEvent: IEventPreview
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPreviewBaseCard',
  props: {
    previewEvent: null
  },
  setup(__props: any) {

const vuetify = useVuetify()
const isDesktopTablet = computed(() => vuetify.breakpoint.smAndUp)



return { __sfc: true,vuetify, isDesktopTablet, EventCardMobile, EventCardDesktop }
}

})